<template>
  <div class>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        <v-icon class="icon">fa-calendar-alt</v-icon>Manage Deadlines
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-toolbar dark color="secondary">
      <v-chip color text-color="white" @click="e1 = 1" class="mr-2">
        <v-avatar>
          <!--<v-icon>account_circle</v-icon>-->
        </v-avatar>
        {{ selectedTotal }} Selected Users
      </v-chip>
      <v-chip color text-color="white" @click="e1 = 3">
        <v-avatar>
          <v-icon x-small>fa-calendar-alt</v-icon>
        </v-avatar>
        Deadline - {{ selectedDate }}
      </v-chip>
    </v-toolbar>
    <div id="slideout-container">
      <v-stepper v-model="e1" class="no-transition">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">Select Users</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2">Set Deadline</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" class="max-height-list scroll-y">
            <v-text-field
              v-model="search"
              label="Filter Users By Name"
              type="text"
              @change="applySearch"
            ></v-text-field>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              :loading="loading"
              :items="users"
              item-key="id"
              show-select
            ></v-data-table>
          </v-stepper-content>
          <v-stepper-content step="2" class="max-height-list scroll-y">
            <date-picker></date-picker>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <div v-if="e1 == 1">
          <v-btn color="primary" class="mr-1" @click="closePanel">Cancel</v-btn>
          <v-btn color="primary" @click="e1 = 2">Next</v-btn>
        </div>
        <div v-if="e1 == 2">
          <v-btn color="primary" class="mr-1" @click="e1 = 1">Back</v-btn>
          <v-btn v-if="loading" color="primary" loading></v-btn>
          <v-btn v-else color="primary" @click="updateDeadline">Update Deadline</v-btn>
        </div>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";
import DatePicker from "@/components/admin/global/Datepicker";
export default {
  name: "ManageDeadlines",
  components: {
    DatePicker
  },
  props: {
    id: {
      type: String,
      default: null
    },
    params: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      headers: [
        { text: "First Name", value: "first_name" },
        { text: "Surname", value: "last_name" },
        { text: "Email", value: "email" },
        //{ text: "Deadline", value: "deadline" }
      ],
      loading: false,
      e1: 1,
      selected: [],
      search: "",
      users: [],
      searchParams: "",
      options: {},
      loading: false,
      pagination: {},
      selectedDate: "Not Set",
      deadlineSet: false,
      successMessage: "Users Successfully Enrolled.",
      errorMessage: "Oops, something went wrong!",
      nothingSelected: "You havent selected any Users or Groups.",
      deadlineNotSet: "You havent set a Deadline."
    };
  },
  computed: {
    serverItemsLength: function() {
      return this.pagination.total;
    },
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    selectedTotal: function() {
      return this.selected.length;
    }
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true
    }
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    getUsers() {
      this.loading = true;
      courseAPI
        .getCourseEnrolledUsers(this.id, this.params, this.searchParams)
        .then(resp => {
          this.users = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    applyUserSearch() {
      this.searchParams =
        this.params +
        "&search=first_name:" +
        this.search +
        ";last_name:" +
        this.search;
      this.getUsers();
    },
    processSelected() {
      let users = [];
      this.selected.forEach(function(x) {
        users.push(x.id);
      });
      return users;
    },
    process() {
      this.loading = true;
      courseAPI
        .updateDeadline(this.id, {
          users: this.processSelected(),
          selectedDate: this.selectedDate
        })
        .then(() => {
          EventBus.$emit("COURSES_UPDATED", this.params);
          this.closePanel();
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(() => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    contine(toast) {
      this.$snotify.remove(toast.id);
      this.selectedDate = "";
      this.process();
    },
    setADate(toast) {
      this.$snotify.remove(toast.id);
      this.loading = false;
      this.el = 3;
    },
    updateDeadline() {
      // this.selectedDate = "";
      this.process();
    },
    setEventBus() {
      EventBus.$on("DATE_SELECTED", date => {
        this.deadlineSet = true;
        this.selectedDate = date;
      });
    },
    closePanel() {
      this.$emit("closePanel", {});
    }
  }
};
</script>
<style media="screen">
#slideout-container {
  height: calc(100vh - 65px - 100px);
}
.max-height-list {
  height: calc(100vh - 65px - 100px - 48px);
}
.no-transition .stepper__content {
  transition: none;
}
</style>
